import { render, staticRenderFns } from "./BaseNavigationLevel.vue?vue&type=template&id=f7542fcc"
import script from "./BaseNavigationLevel.vue?vue&type=script&lang=ts"
export * from "./BaseNavigationLevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports